// extracted by mini-css-extract-plugin
module.exports = {"phone-number-input":"PhoneNumberInput_phone-number-input__3nri5"};